module.exports = __webpack_public_path__ + "static/media/img_ai_03.1b2d7280.png";